import Dbm from "dbm";
import Website from "../../../index.js";

export default class Paper extends Dbm.core.BaseObject {
    _construct() {
        super._construct();

        let container = new PIXI.Container();
        this.item.setValue("pixiLayer", container);
        
        this.item.setValue("originalInertia", 0);
        this.item.setValue("groundOffset", 3);
    }

    createStack(aNumberOfPapers = 4) {
        let paperTextures = Website.game.getTextures("screens/gameover/papers", "layer");
        let numberOfPaperTextures = paperTextures.length;

        for(let i = 0; i < aNumberOfPapers; i++) {
            let index = Math.floor(Math.random()*numberOfPaperTextures);
            let currentSprite = new PIXI.Sprite(paperTextures[index]);
            currentSprite.anchor.set(0.5, 0.5);

            let randomOffset = Math.round(1*((Math.random()*2-1)));
            currentSprite.position.set(randomOffset, 2*(0.5*(aNumberOfPapers-1)-i));
            this.item.pixiLayer.addChild(currentSprite);
        }
    }

    setup(aFront = true) {

        let collisionFilter;
        if(aFront) {
            collisionFilter = Website.game.PhysicsGroups.createCollisionFilter(Website.game.PhysicsGroups.TABLE_ITEM_FRONT, Website.game.PhysicsGroups.TABLE_ITEM_FRONT_INTERACTIONS);
        }
        else {
            collisionFilter = Website.game.PhysicsGroups.createCollisionFilter(Website.game.PhysicsGroups.TABLE_ITEM_BACK, Website.game.PhysicsGroups.TABLE_ITEM_BACK_INTERACTIONS);
        }

        let mainBody = Matter.Bodies.rectangle(0, 0, 20, 8, {
            label: "paper",
            restitution: 0,
            collisionFilter: collisionFilter
        });

        let left = Matter.Bodies.circle(-10, 0, 4, {
            label: "paper",
            restitution: 0,
            collisionFilter: collisionFilter
        });

        let right = Matter.Bodies.circle(10, 0, 4, {
            label: "paper",
            restitution: 0,
            collisionFilter: collisionFilter
        });

        let body = Matter.Body.create({
            parts: [mainBody, left, right],
            label: "paper-compound",
            restitution: 0,
            mass: 0.01,
            collisionFilter: collisionFilter
        });

        this.item.originalInertia = body.inertia;
        Matter.Body.setInertia(body, Infinity);

        this.item.setValue("physicsBody", body);
    }

    update(aTime, aDelta) {

        let basePosition = Website.game.Sizes.GROUND_POSITION+Website.game.Sizes.PLAYER_POSITION+10-this.item.groundOffset;

        this.item.pixiLayer.x = this.item.physicsBody.position.x;
        this.item.pixiLayer.y = this.item.physicsBody.position.y+basePosition;

        this.item.pixiLayer.rotation = this.item.physicsBody.angle;
    }
}